import InputLabel from './ui/InputLabelUi'

export default InputLabel
